<template lang="pug">
  section.dashboard
    h1.page-title User Search
    .search-wrapper
      .search-form
        form(autocomplete="off" v-on:submit.prevent="searchByEmail")
          fieldset
            label(for="email") Email Address
            input(type="text" id="email" placeholder="Full Email Address" v-model.trim="email")
          input.btn.search-user-btn(type="submit" value="Search Email" :disabled="!email")

        form(autocomplete="off" v-on:submit.prevent="search")
          h4.center-heading OR
          fieldset
            label(for="fname") First Name
            input(type="text" id="fname" placeholder="Full First Name" v-model.trim="userQuery.firstName")
          fieldset
            label(for="lname") Last Name
            input(type="text" id="lname" placeholder="Full Last Name" v-model.trim="userQuery.lastName")
          fieldset
            label(for="dob") Date Of Birth
            .dob-fields
              input(type="number" min="1" max="12" id="dob-mm" placeholder="mm" v-model.number="userQuery.dobMonth")
              input(type="number" min="1" max="31" id="dob-dd" placeholder="dd" v-model.number="userQuery.dobDay")
              input(type="number" min="1" id="dob-yyyy" placeholder="yyyy" v-model.number="userQuery.dobYear")
            .error(v-if="showDobError")
              | * Invalid date
          input.btn.search-user-btn(type="submit" value="Search User" :disabled="!hasUserSearch")
      .search-results
        table.patient-list(v-if="searchSubmitted")
          thead
            tr
              th First
              th Last
              th.wide Email
              th.narrow.has-tooltip(v-on:mouseenter="showDOB(true)" v-on:mouseleave="!showDOB(false)")
                span.link-highlight DOB/Age ?
                transition(name="zoom-fade")
                  .tooltip-content(v-if="showDOBLegend")
                    section.tooltip-body
                      p myStrength may have collected age or DOB at time of registration. If age was collected, the age shown here will be an
                        | estimate within + or - 1 year. Birthdates are shown only with year on the listing page for security precautions but
                        | the full birthdate can be seen on the user detail page.
              th.action &nbsp;
          tbody
            tr(v-for="patient in patientSearch")
              td {{ patient.firstName }}
              td {{ patient.lastName }}
              td
                span.text-overflow {{ patient.emailAddress }}
              td {{ dateOfBirth(patient) }}
              td.action
                router-link.btn.small(:to="{ name: 'Patient', params: { id: patient.id }}" tag="button") View Profile
            tr(v-if="patientSearch.length === 0")
              td(colspan="5")
                | No users to display
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import profileMixin from '@/mixins/profileInfo.js';

export default {
  name: 'Search',
  data() {
    return {
      searchSubmitted: false,
      showDobError: false,
      showDOBLegend: false,
      email: null,
      userQuery: {
        firstName: null,
        lastName: null,
        dobMonth: null,
        dobDay: null,
        dobYear: null
      }
    };
  },
  computed: {
    hasUserSearch() {
      return (this.userQuery.firstName && this.userQuery.firstName !== '') ||
        (this.userQuery.lastName && this.userQuery.lastName !== '') ||
        (this.hasDob && this.validDob);
    },
    hasDob() {
      return (this.userQuery.dobMonth && this.userQuery.dobDay && this.userQuery.dobYear);
    },
    validDob() {
      if (!this.userQuery.dobMonth || !this.userQuery.dobDay || !this.userQuery.dobYear) {
        return false;
      }
      let dt = moment({ month: (this.userQuery.dobMonth - 1), day: this.userQuery.dobDay, year: this.userQuery.dobYear });
      return dt.isValid() && moment().isAfter(dt);
    },
    ...mapGetters([
      'patientSearch'
    ])
  },
  methods: {
    searchByEmail() {
      this.searchSubmitted = true;
      this.searchPatients({ email: this.email });
    },
    search() {
      if ((this.hasDob && !this.validDob)) {
        this.showDobError = true;
        return;
      }
      this.showDobError = false;
      this.searchSubmitted = true;
      this.searchPatients(this.userQuery);
    },
    ...mapActions([
      'searchPatients'
    ]),
    showDOB(show) {
      this.showDOBLegend = show;
    }
  },
  mixins: [ profileMixin ]
};
</script>

<style lang="scss" scoped>

  .search-wrapper {
    margin: 0 auto $base-spacing;
    display: flex;
    justify-content: space-between;
  }

  .search-form {
    flex: 0 1 30%;
    min-width: 360px;
    margin-right: $base-spacing;
    padding: $small-spacing 0;
    background: #fff;
    @include drop-shadow;
    fieldset {
      padding: 0 $small-spacing;
      margin: 0 auto $small-spacing;
    }
    .center-heading {
      margin: $xs-spacing auto;
      line-height: 1;
    }
    .dob-fields {
      display: flex;
      justify-content: space-between;
      input {
        width: 32%;
        flex: 0 1 32%;
        margin-right: 2px;
        &:last-of-type {
          margin-right: 0;
        }
      }
    }
    .error {
      color: $error-color;
    }
    .search-user-btn {
      margin: 0 0 0 $small-spacing;
    }
  }
  .search-results {
    flex: 0 1 70%;
  }
  th.action, td.action {
    max-width: 120px;
    text-align: right;
  }
  th.wide, td.wide {
    width: 33%;
  }
  th.narrow, td.narrow {
    width: 16%;
  }

  .text-overflow {
    display: block;
    padding-right: 1em;
    @include text-overflow;
  }

  .patient-list-wrapper {
    display: flex;
    justify-content: space-between;
  }
  .patient-entries {
    width: 78%;
  }
  .patient-snapshot {
    width: 20%;
    position: relative;
  }
</style>
